import React, { ReactNode } from 'react';
import AdminBox from '../../../Utility/AdminBox';
import ResetButton from './ResetButton';
import { Prompt as PromptType } from '../../../../Types';
import { AssistantTabs } from '../../../../Types/Enums';

interface ConfigBoxProps {
    title: string;
    description: string | ReactNode;
    disabledDescription?: string;
    changed?: boolean;
    disabled?: boolean;
    targetTab: AssistantTabs;
    configKey?: string;
    showReset?: boolean;
    prompt?: PromptType;
    promptSnapshot?: PromptType;
    PromptActions?: any;
    stopPropagation?: boolean;
    className?: string;
    onClick?: () => void;
}

const ConfigBox: React.FC<ConfigBoxProps> = ({
    title,
    description,
    disabledDescription,
    changed = false,
    disabled = false,
    targetTab,
    configKey,
    showReset = false,
    prompt,
    promptSnapshot,
    PromptActions,
    stopPropagation = true,
    className = '',
    onClick,
}) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (PromptActions && !disabled) {
            PromptActions.openTab(targetTab);
        }
    };

    const boxClassName = `
        mb-0
        relative
        ${!disabled ? 'cursor-pointer hover:bg-configbox-hoverColor' : 'pointer-events-none opacity-50'}
        transition-all duration-150
        ${className}
    `;

    return (
        <AdminBox classString={boxClassName} onClick={handleClick}>
            {showReset && configKey && prompt && promptSnapshot && PromptActions && (
                <div className="absolute top-4 right-4">
                    <ResetButton
                        configKey={configKey}
                        prompt={prompt}
                        promptSnapshot={promptSnapshot}
                        PromptActions={PromptActions}
                        stopPropagation={stopPropagation}
                    />
                </div>
            )}
            <h6 className="mb-0">{title}</h6>
            <span className="block my-2 text-xs text-gray-500">
                {disabled && disabledDescription ? disabledDescription : description}
            </span>
        </AdminBox>
    );
};

export default ConfigBox;
